import { render, staticRenderFns } from "./UpdateMerchantBusinessAddressModal.vue?vue&type=template&id=b4b81846&scoped=true&"
import script from "./UpdateMerchantBusinessAddressModal.vue?vue&type=script&lang=js&"
export * from "./UpdateMerchantBusinessAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMerchantBusinessAddressModal.vue?vue&type=style&index=0&id=b4b81846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b81846",
  null
  
)

export default component.exports